import { useContext } from 'react'
import { FormContext } from '@/components/changeRequests/formContext'
import { actionCreators } from '@/store/Forms'
import { useDispatch } from '@/hooks/dispatch'
import { usePropertyReader } from '@/hooks/usePropertyReader'

export function usePropertySetter (propertyName, areValuesEqual = (prop, value) => prop !== value) {
  const [ prop ] = usePropertyReader([propertyName])
  const { uid } = useContext(FormContext)
  const [ change ] = useDispatch([actionCreators.change])
  return (value) => {
    if (!areValuesEqual(prop, value)) change(uid, propertyName, value)
  }
}



// WEBPACK FOOTER //
// ./src/hooks/usePropertySetter.js